export function isToday(date: Date | string): boolean {
  const _date = new Date(date);
  const today = new Date();
  return equalDates(_date, today);
}

export function equalDates(firstDate: Date, secondDate: Date): boolean {
  firstDate = new Date(firstDate);
  secondDate = new Date(secondDate);
  if (!firstDate || !secondDate) {
    return false;
  }

  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
}
